import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { mascaraData, paraTextoBR, validarData } from '../../global/dataDigitada';

/**
 * Campo de data digitado (dd/mm/aaaa).
 *
 * Substitui o calendario do navegador, que os clientes reclamaram ser lento de
 * navegar. Aceita e devolve a data em 'aaaa-mm-dd'; enquanto a pessoa digita,
 * o valor so sobe para o formulario quando a data e valida.
 *
 * value        - 'aaaa-mm-dd', Date ou vazio
 * onChange     - recebe 'aaaa-mm-dd' ou '' (data incompleta/invalida)
 * naoFuturo    - bloqueia data futura (usar em data de nascimento)
 * minima/maxima- Date ou 'aaaa-mm-dd'
 * erro/textoAuxiliar - erro vindo do formulario (Yup, backend etc.)
 */
export default ({
    label = 'Data',
    value,
    onChange,
    onBlur,
    obrigatorio = false,
    naoFuturo = false,
    minima,
    maxima,
    rotuloMinima,
    rotuloMaxima,
    erro = false,
    textoAuxiliar = '',
    disabled = false,
    size = 'small',
    fullWidth = true,
    name,
    ...resto
}) => {
    const [texto, setTexto] = useState(paraTextoBR(value));
    const [tocado, setTocado] = useState(false);

    // Valor vindo de fora (carregou o cadastro, resetou o form) reescreve o campo,
    // menos enquanto a pessoa esta digitando uma data ainda incompleta
    useEffect(() => {
        const deFora = paraTextoBR(value);
        if (deFora && deFora !== texto) setTexto(deFora);
        if (!value && texto.replace(/\D/g, '').length === 8) setTexto('');
    }, [value]);

    const opcoes = { obrigatorio, naoFuturo, minima, maxima, rotuloMinima, rotuloMaxima };
    const resultado = validarData(texto, opcoes);

    const digitar = evento => {
        const novo = mascaraData(evento.target.value);
        setTexto(novo);

        const parcial = validarData(novo, opcoes);
        // Data incompleta ou invalida limpa o valor do formulario: melhor vazio
        // do que uma data que a pessoa nao terminou de escrever
        onChange?.(parcial.valida ? parcial.iso : '');
    };

    const mostrarErro = (tocado || erro) && (!resultado.valida || erro);

    return (
        <TextField
            {...resto}
            name={name}
            label={label}
            placeholder="dd/mm/aaaa"
            value={texto}
            onChange={digitar}
            onBlur={evento => {
                setTocado(true);
                onBlur?.(evento);
            }}
            disabled={disabled}
            size={size}
            fullWidth={fullWidth}
            error={Boolean(mostrarErro)}
            helperText={mostrarErro ? (resultado.erro || textoAuxiliar) : textoAuxiliar}
            InputLabelProps={{ shrink: true }}
            inputProps={{ inputMode: 'numeric', maxLength: 10, ...(resto.inputProps || {}) }}
        />
    );
};
